import { defineComponent as S, useSlots as _, ref as h, computed as B, openBlock as l, createBlock as x, unref as s, withCtx as m, renderSlot as v, createElementBlock as o, normalizeClass as N, createElementVNode as p, normalizeStyle as g, createCommentVNode as f, Fragment as P, renderList as $ } from "vue";
import "./ghl-ui.es450.js";
import z from "./ghl-ui.es174.js";
import E from "./ghl-ui.es216.js";
const L = {
  key: 0,
  class: "hl-color-picker-dropdown-container"
}, V = {
  key: 0,
  class: "hl-color-picker-header"
}, A = { class: "hl-colors-list" }, F = ["onClick"], I = S({
  __name: "SwatchesPicker",
  props: {
    swatches: {
      type: Array,
      default: void 0
    },
    trigger: {
      type: String,
      default: "click"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    value: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onClickColor"],
  setup(t, { emit: k }) {
    var d;
    const c = _(), i = t, r = h([]);
    (d = i.swatches) != null && d.length ? r.value = i.swatches.map((e) => e.toLowerCase().trim()).filter((e, u, a) => a.indexOf(e) === u) : r.value = [];
    const n = h(), w = B(() => n.value), C = k, y = (e) => {
      n.value = e, C("onClickColor", e);
    };
    return (e, u) => (l(), x(s(E), {
      ref: "popper",
      raw: "",
      trigger: t.trigger,
      placement: t.placement,
      value: t.value,
      class: "hl-color-picker-popover",
      "show-arrow": !1,
      show: t.show,
      disabled: t.disabled
    }, {
      trigger: m(() => [
        s(c).trigger ? v(e.$slots, "trigger", {
          key: 0,
          value: t.value
        }, void 0, !0) : (l(), o("div", {
          key: 1,
          class: N([
            "hl-color-picker__trigger",
            t.disabled ? "hl-swatches-disabled" : ""
          ])
        }, [
          p("span", {
            class: "hl-color-picker__selected-swatch",
            style: g({ backgroundColor: w.value })
          }, null, 4)
        ], 2))
      ]),
      default: m(() => [
        r.value.length ? (l(), o("div", L, [
          s(c).header ? (l(), o("div", V, [
            v(e.$slots, "header", {}, void 0, !0)
          ])) : f("", !0),
          p("div", A, [
            (l(!0), o(P, null, $(r.value, (a, b) => (l(), o("div", {
              class: "hl-color-circle",
              key: b,
              style: g({ backgroundColor: a }),
              onClick: (O) => y(a)
            }, null, 12, F))), 128))
          ])
        ])) : f("", !0)
      ]),
      _: 3
    }, 8, ["trigger", "placement", "value", "show", "disabled"]));
  }
}), H = /* @__PURE__ */ z(I, [["__scopeId", "data-v-a1b3bda8"]]);
export {
  H as default
};
